import { classes } from 'html-classes';

import { company } from '~/company/Company';
import { ProductCardSkeletonProps } from '~/components/ProductCardV3/skeletons/types';

import styles from './ProductCardSkeletonM.module.scss';

/**
 * ProductCardSkeletonM - Loading skeleton for ProductCardM
 * Matches exact dimensions and layout of ProductCardM (179px mobile, 227px web)
 */
const ProductCardSkeletonM = ({ className }: ProductCardSkeletonProps) => {
  return (
    <div
      className={classes([styles.skeleton, className])}
      data-company={company.name}
    >
      {/* Image skeleton with favorite icon */}
      <div className={styles.imageWrapper}>
        <div className={styles.imageSkeleton}>
          {!company.isMarketplaceVariant && (
            <div className={styles.favoriteIcon} />
          )}
        </div>
      </div>

      {/* Info section skeleton */}
      <div className={styles.infoWrapper}>
        {/* Name section */}
        <div className={styles.nameSection}>
          <div className={styles.nameLine} />
          <div className={classes([styles.nameLine, styles.nameLine_short])} />
        </div>

        {/* Rating and volume section */}
        <div className={styles.volumeLine} />

        {/* Price and button section */}
        <div className={styles.bottomSection}>
          <div
            className={classes([
              styles.priceColumn,
              company.isMarketplaceVariant && styles.priceColumnMarketplace,
            ])}
          >
            <div
              className={classes([
                styles.priceLine,
                company.isMarketplaceVariant && styles.priceLineMarketplace,
              ])}
            />
            <div
              className={classes([
                styles.discountLine,
                company.isMarketplaceVariant && styles.discountLineMarketplace,
              ])}
            />
          </div>
          {!company.isMarketplaceVariant && (
            <div className={styles.buttonSkeleton} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCardSkeletonM;
